import React from "react";
import DisabledLineItem from "./DisabledLineItem";

class EnabledRatesDataType extends React.Component{
  
  constructor(props) {
    super(props);
  }

  render() {
    if (this.props.row.rates && this.props.row.rates.length > 0) {

      var rates = [];

      for (let step = 0; step < this.props.row.rates.length; step++) {
        if (step < 4) {
          if (this.props.row.rates[step] && this.props.row.rates[step].status == 'enabled') {
            rates.push(<li key={this.props.row.rates[step].id}>{this.props.row.rates[step].code} - {this.props.row.rates[step].name}</li>);
          } else {
            rates.push(<DisabledLineItem key={this.props.row.rates[step].id} disabledRates={true} {...this.props.row.rates[step]} />);
          };
        } else if (step === 4) {
          rates.push(<li key='additional-room-types'><i>... {` ${I18n.t('more')}`}</i></li>)
        };
      };

      return (
        <ul style={{marginBottom: 0}}>{rates}</ul>
      );
    } else {
      return <span className="none">{I18n.t('none')}</span>;
    }
  }

};

export default EnabledRatesDataType